import { CalloutContent, CalloutVariant } from '../../entities/callout-content.entity';

export const CommonCallout_UploadError_ProtectedPdf = {
  calloutVariant: CalloutVariant.Emergency,
  headerText: 'Password protected PDFs',
  emphasis: `medium`,
  bodyText: `<p>Bank statements downloaded from online banking are often password protected automatically.</p>
      <p>You can remove the password by following these steps:</p>
      <p><b>Option 1 - Re-save the PDF</b></p>
      <ul>
        <li>Open the PDF in your web browser or in a free Adobe Acrobat Reader</li>
        <li>Select "print" and "save as PDF"</li>
        <li>Save it under a new name and try to upload it again.</li>
      </ul>
      <p><b>Option 2 - Screenshot</b></p>
      <ul>
        <li>
          If Option 1 doesn't work, open the PDF and take clear screenshots of each page, then upload those images
          instead (JPG or PNG).
        </li>
      </ul>`,
} as CalloutContent;

export const CommonCallout_UploadError_ProtectedPdfFallback = {
  calloutVariant: CalloutVariant.Emergency,
  headerText: 'Password protected PDFs',
  emphasis: `medium`,
  bodyText: `<p>This application currently does not accept password protected or encrypted PDFs.</p>
      <p>You can remove the password by following these steps:</p>
      <p><b>Option 1 - Re-save the PDF</b></p>
      <ul>
        <li>Open the PDF in your web browser or in a free Adobe Acrobat Reader</li>
        <li>Select "print" and "save as PDF"</li>
        <li>Save it under a new name and try to upload it again.</li>
      </ul>
      <p><b>Option 2 - Screenshot</b></p>
      <ul>
        <li>
          If Option 1 doesn't work, open the PDF and take clear screenshots of each page, then upload those images
          instead (JPG or PNG).
        </li>
      </ul>`,
} as CalloutContent;
